import octopusDynamicExtensions from "./octopusDynamicExtensions";

export * from "./octopusDynamicExtensions";
export default octopusDynamicExtensions;
